module.exports = __webpack_public_path__ + "static/media/placeholder.b58126d3.jpg";